import * as React from "react";
interface SvgComponentProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}
const SvgComponent = (props: SvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill={props.fill || "none"}
    {...props}
  >
    <path
      stroke={props.stroke || "#8F8F8F"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.75 6.5 18 11.75m-2.625-2.625-9 9m2.577 2.577-5.154-5.154M8.69 20.75H4.5a.75.75 0 0 1-.75-.75v-4.19a.75.75 0 0 1 .22-.53L15.53 3.72a.75.75 0 0 1 1.06 0l4.19 4.186a.75.75 0 0 1 0 1.06L9.22 20.532a.75.75 0 0 1-.53.219Z"
    />
  </svg>
);
export default SvgComponent;
